import { SelectOption } from "../../../molecule/inputs/select-input"
import { CSSProperties, useMemo } from "react"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SearchSelect from "Components/molecule/inputs/search-select"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import useEnterSearch from "hooks/useEnterSearch"
import { IBudgetLineQueryParam } from "models/budget-line"

interface SearchBudgetLinesProps {
    handleChangeQuery: (key: string, value: any) => any,
    query: IBudgetLineQueryParam
    branches: SelectOption[]
    departments: SelectOption[]
    handleClearSearch: () => any
    handleSearch: () => any
    style?: CSSProperties
    hide?: {
        department?: boolean,
        branch?: boolean
    },
    fields?: {
        branch?: string,
        department?: string
    }
    isSearching: boolean
}

const SearchBudgetLinesForm = ({
    query,
    handleChangeQuery,
    branches,
    departments,
    handleClearSearch,
    handleSearch,
    hide,
    fields,
    isSearching
}: SearchBudgetLinesProps) => {

    const { selectProps } = useEnterSearch(handleSearch)

    return <SearchFormContainer
        inputs={<>
            {
                !hide?.branch &&
                <SearchSelect
                    className="col"
                    label={"Branch"}
                    value={query.branchId ?? null}
                    onChange={(e) => handleChangeQuery(fields?.branch ? fields.branch : 'branchId', e?.value ?? '')}
                    options={branches}
                    {...selectProps}
                />
            }
            {
                !hide?.department &&
                <SearchSelect
                    className="col"
                    label={"Division"}
                    value={query.departmentId ?? null}
                    onChange={(e) => handleChangeQuery(fields?.department ? fields.department : 'departmentId', e?.value ?? '')}
                    options={departments}
                    {...selectProps}
                />
            }
        </>}
        clearSearchButton={
            <>
                <PrimaryButton
                    style={{
                        minWidth: '150px'
                    }}
                    disabled={isSearching}
                    onClick={handleSearch}
                >
                    {isSearching ? 'Searching...' : 'Search'}
                </PrimaryButton>
                <SecondaryButton
                    style={{
                        minWidth: '100px'
                    }}
                    disabled={isSearching}
                    onClick={handleClearSearch}
                >
                    Clear Search
                </SecondaryButton>
            </>
        }
    />

}

export default SearchBudgetLinesForm